/* eslint-disable react/prop-types, react/destructuring-assignment */
import clsx from 'clsx'
import { Formik } from 'formik'
import { isNull } from 'lodash'
import React, { useState } from 'react'
import { Button, Col, Form, Modal } from 'react-bootstrap'
import { FormattedMessage, injectIntl } from 'react-intl'
import PhoneInput from 'react-phone-input-2'
import * as Yup from 'yup'
import { updateEmployee } from '../../../crud/employees.crud'

function EditEmployeeModal(props) {
  const { show, onHide, onUpdate, intl, employee } = props

  const [phone, setPhone] = useState()
  const [loading, setLoading] = useState(false)
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingLeft: '2.5rem',
    paddingRight: '2.5rem',
  })
  const [status, setStatus] = useState()

  const schema = Yup.object({
    firstName: Yup.string()
      .min(
        2,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_SHORT',
        }),
      )
      .max(
        50,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_LONG',
        }),
      )
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        }),
      ),
    lastName: Yup.string()
      .min(
        2,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_SHORT',
        }),
      )
      .max(
        50,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_LONG',
        }),
      )
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        }),
      ),
    email: Yup.string()
      .email()
      .min(
        5,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_SHORT',
        }),
      )
      .required(
        intl.formatMessage({
          id: 'AUTH.VALIDATION.REQUIRED_FIELD',
        }),
      ),
    department: Yup.string().max(
      50,
      intl.formatMessage({
        id: 'AUTH.VALIDATION.TOO_LONG',
      }),
    ), // Optional field
    jobTitle: Yup.string()
      .min(
        2,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_SHORT',
        }),
      )
      .max(
        50,
        intl.formatMessage({
          id: 'AUTH.VALIDATION.TOO_LONG',
        }),
      ),
  })

  /* eslint-disable no-nested-ternary */
  const initialValues = {
    firstName: employee ? employee.first_name : '',
    lastName: employee ? employee.last_name : '',
    email: employee ? employee.email : '',
    phone: employee ? employee.phone : '',
    department: employee ? (isNull(employee.department) ? '' : employee.department) : '',
    jobTitle: employee ? (isNull(employee.job_title) ? '' : employee.job_title) : '',
  }
  /* eslint-enable no-nested-ternary */

  async function handleSubmit(values) {
    // eslint-disable-next-line no-use-before-define
    enableLoading()
    // eslint-disable-next-line no-shadow
    const employee = {
      Customer: props.employee.Customer,
      id: props.employee.id,
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      phone,
      department: values.department,
      job_title: values.jobTitle,
    }
    // eslint-disable-next-line no-use-before-define
    updateThisEmployee(employee)
  }

  // eslint-disable-next-line no-shadow
  async function updateThisEmployee(employee) {
    try {
      await updateEmployee(employee)
      // eslint-disable-next-line no-use-before-define
      hide()
      // eslint-disable-next-line no-use-before-define
      update()
    } catch (e) {
      console.error(e.message)
      setStatus(
        <>
          <FormattedMessage id="GENERAL.ERROR" />
          <a href="https://support.augmentt.com" target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="GENERAL.CONTACT_SUPPORT" />
          </a>
        </>,
      )
    }
    // eslint-disable-next-line no-use-before-define
    disableLoading()
  }

  const enableLoading = () => {
    setLoading(true)
    setLoadingButtonStyle({ paddingRight: '3.5rem', paddingLeft: '2.5rem' })
  }

  const disableLoading = () => {
    setLoading(false)
    setLoadingButtonStyle({ paddingRight: '2.5rem', paddingLeft: '2.5rem' })
  }

  const hide = () => {
    onHide()
    setStatus()
  }

  const update = () => {
    onUpdate()
  }

  return (
    <Modal
      id="editEmployeeModal"
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={hide}
      onSubmit={update}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <FormattedMessage id="ADMINISTRATION.EDIT_EMPLOYEE" />
        </Modal.Title>
      </Modal.Header>
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        initialErrors={schema.isValidSync(initialValues)}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({
          // eslint-disable-next-line no-shadow
          handleSubmit,
          handleChange,
          setFieldValue,
          setFieldTouched,
          values,
          errors,
          touched,
        }) => (
          <Form>
            <Modal.Body>
              <Col md="12">
                {status && (
                  <div role="alert" className={`alert alert-${errors ? 'danger' : 'success'}`}>
                    <div className="alert-text">{status}</div>
                  </div>
                )}
              </Col>
              <Form.Group controlId="firstName">
                <Form.Label className="inline">
                  <FormattedMessage id="FORM.FIRST_NAME" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  className="inline"
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_FIRST_NAME',
                  })}
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const val = (e.target.value || '').replace(/\s+/gi, ' ')
                    setFieldValue('firstName', val.trim())
                    setFieldTouched('firstName', true, false)
                  }}
                  onKeyPress={(event) => {
                    if (event.key === ' ' && !event.target.value.length) {
                      event.preventDefault()
                    }
                  }}
                  isInvalid={touched.firstName && !!errors.firstName}
                  isValid={touched.firstName && !errors.firstName}
                />
                <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="lastName">
                <Form.Label className="inline">
                  <FormattedMessage id="FORM.LAST_NAME" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  className="inline"
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_LAST_NAME',
                  })}
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const val = (e.target.value || '').replace(/\s+/gi, ' ')
                    setFieldValue('lastName', val.trim())
                    setFieldTouched('lastName', true, false)
                  }}
                  onKeyPress={(event) => {
                    if (event.key === ' ' && !event.target.value.length) {
                      event.preventDefault()
                    }
                  }}
                  isInvalid={touched.lastName && !!errors.lastName}
                  isValid={touched.lastName && !errors.lastName}
                />
                <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="email">
                <Form.Label className="inline">
                  <FormattedMessage id="FORM.EMAIL" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  className="inline"
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_EMAIL',
                  })}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const val = (e.target.value || '').replace(/\s+/gi, ' ')
                    setFieldValue('email', val.trim())
                    setFieldTouched('email', true, false)
                  }}
                  onKeyPress={(event) => {
                    if (event.key === ' ' && !event.target.value.length) {
                      event.preventDefault()
                    }
                  }}
                  isInvalid={touched.email && !!errors.email}
                  isValid={touched.email && !errors.email}
                />
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="phone">
                <Form.Label className="inline">
                  <FormattedMessage id="ADMINISTRATION.PHONE" />
                </Form.Label>
                <PhoneInput
                  name="phone"
                  preferredCountries={['ca', 'us', 'gb']}
                  country="ca"
                  value={values.phone ? values.phone : undefined}
                  // eslint-disable-next-line no-shadow
                  onChange={(phone) => setPhone(phone)}
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_PHONE',
                  })}
                  disableCountryCode={!phone && initialValues.phone === ''}
                />
              </Form.Group>
              <Form.Group controlId="employeeDepartment">
                <Form.Label className="inline">
                  <FormattedMessage id="FORM.DEPARTMENT" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="department"
                  className="inline"
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_DEPARTMENT',
                  })}
                  value={values.department}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const val = (e.target.value || '').replace(/\s+/gi, ' ')
                    setFieldValue('department', val.trim())
                    setFieldTouched('department', true, false)
                  }}
                  onKeyPress={(event) => {
                    if (event.key === ' ' && !event.target.value.length) {
                      event.preventDefault()
                    }
                  }}
                  isInvalid={touched.department && !!errors.department}
                  isValid={touched.department && !errors.department}
                />
                <Form.Control.Feedback type="invalid">{errors.department}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="employeeJobTitle">
                <Form.Label className="inline">
                  <FormattedMessage id="FORM.JOB_TITLE" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="jobTitle"
                  className="inline"
                  placeholder={intl.formatMessage({
                    id: 'PLACEHOLDER.ENTER_JOB_TITLE',
                  })}
                  value={values.jobTitle}
                  onChange={handleChange}
                  onBlur={(e) => {
                    const val = (e.target.value || '').replace(/\s+/gi, ' ')
                    setFieldValue('jobTitle', val.trim())
                    setFieldTouched('jobTitle', true, false)
                  }}
                  onKeyPress={(event) => {
                    if (event.key === ' ' && !event.target.value.length) {
                      event.preventDefault()
                    }
                  }}
                  isInvalid={touched.jobTitle && !!errors.jobTitle}
                  isValid={touched.jobTitle && !errors.jobTitle}
                />
                <Form.Control.Feedback type="invalid">{errors.jobTitle}</Form.Control.Feedback>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={hide} variant="light">
                <FormattedMessage id="GENERAL.CANCEL" />
              </Button>
              <Button
                // eslint-disable-next-line react/jsx-no-bind
                onClick={handleSubmit}
                disabled={loading}
                id="editUserSubmit"
                variant="primary"
                className={`btn-elevate adduser__btn-primary ${clsx({
                  'spinner spinner--right spinner--md spinner--light': loading,
                })}`}
                style={loadingButtonStyle}
              >
                <FormattedMessage id="GENERAL.UPDATE" />
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default injectIntl(EditEmployeeModal)
